import React from "react";

export default function AudioMessage({ msg }) {
  const url = msg.file?.url || msg.attach?.url || "";
  return (
    <div className="imc-bubble imc-bubble-audio">
      <audio src={url} controls />
    </div>
  );
}
